/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phoneplaceholder1Inputs */

const en_phoneplaceholder1 = /** @type {(inputs: Phoneplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1 234 567 8900`)
};

const de_phoneplaceholder1 = /** @type {(inputs: Phoneplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1 234 567 8900`)
};

/**
* | output |
* | --- |
* | "+1 234 567 8900" |
*
* @param {Phoneplaceholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const phoneplaceholder1 = /** @type {((inputs?: Phoneplaceholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phoneplaceholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phoneplaceholder1(inputs)
	return de_phoneplaceholder1(inputs)
});
export { phoneplaceholder1 as "phonePlaceholder" }